import { JSEncrypt } from 'encryptlong'
import I18n from '@/locals';

/* RSA公钥 */
export const RsaPublicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCqZ9t3wiqP/OyXHo6Mi0oQEDrDqGQsvPW+bCVbVmt3t4PHQj+vsbL0KuvaZJOMLfCPA4dFbOjEwRf8jyMXiqv9NIciY+Wo/YVssi5TdVCti2U/IZ+rTaYPrS9xNEEfbnQ1OOjQwWU+lHIxL0v9h3i/G5cK3ul0Crt5A5VIJUAE7wIDAQAB'

/**
 * @function RSA加密
 *  @param RsaEncryptText {string} 需要加密的内容
 *  @param publicKey {String} RSA公钥，如果不传则是默认RSA公钥
 * @return {String}
 */
export const RsaEncrypt = (RsaEncryptText: string, publicKey?: string): string => {
  const enc = new JSEncrypt()
  enc.setPublicKey(publicKey || RsaPublicKey)
  return enc.encryptLong(RsaEncryptText)
}

/* 密码强度校验 */
export const passwordVerify = (password: string) => {
  const { t } = I18n.global;
  password = String(password)
  const blankRegex = /\s/g
  const lengthRegex = /^.{8,}$/
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\w\W]{8,}$/
  if (blankRegex.test(password)) return t('login.passwordBlankErr')
  if (!lengthRegex.test(password)) return t('login.passwordLengthErr')
  if (!passwordRegex.test(password)) return t('login.passwordStrengthErr')
}
